/**
 * KAN-988: функции тарифа. Коды те же, что у backend (features в /auth/me и
 * у плана в /billing/plans/). Подписи функций только отсюда: меню, экран
 * FeatureGuard и витрина тарифов.
 */
export type FeatureCode = 'crm' | 'bot_learning' | 'manager_alerts' | 'manager_app';

export const FEATURE_LABELS: Record<FeatureCode, string> = {
  crm: 'CRM',
  bot_learning: 'Обучение ботов',
  manager_alerts: 'Сигнализация неразобранных',
  manager_app: 'Приложение менеджера',
};

/** Строка-намёк на месте закрытого блока: функция есть только в старших тарифах. */
export function featureTariffHint(code: string): string {
  return `${featureLabel(code)} доступно в тарифах Продажи и Про`;
}

/** Подпись функции; неизвестный код показывается как есть. */
export function featureLabel(code: string): string {
  return (FEATURE_LABELS as Record<string, string>)[code] ?? code;
}
